import { Row, Col } from 'antd';

const GridContratoSNIva = ({ budget, budget_not_iva }) => {

    const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});
    const budgetNotIva = budget * (budget_not_iva / 100);

    return (
        <>
            <Col xs={24} md={12}>
                <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
                    <h4 className='title-custom'>CONTRATO SIN IVA</h4>
                </Row>

                <table style={{ width: "100%", borderSpacing: "0 6px" }}>
                    <tbody>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Presupuesto SIN IVA:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            $ {numberFormat.format(budgetNotIva) || "0.00"}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Col>
        </>
    )
}

export default GridContratoSNIva;